import React, { useMemo } from 'react';
import Paper from '../../../../../../components/Paper';
import RatingStars from '../../../../../../components/RatingStars';
import Table from '../../../../../../components/Table';
import { makeStyles } from '../../../../../../utils/styles';
import User from '../../../../../../components/User';
import { Col, Row } from 'react-styled-flexboxgrid';
import Box from '../../../../../../components/Box';
import Typography from '../../../../../../components/Typography';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(css => ({
    paper: css`
        margin-top: 10px;
    `,
    footer: css`
        display: flex;
        align-items: center;
        margin-top: 20px;
    `,
    font: css`
        font-size: 14px;
        font-weight: 300;
        margin-right: 40px;
    `
}));

const TableRatings = ({ data }) => {
    const { t } = useTranslation()
    const styles = useStyles();

    const columns = useMemo(
        () => [
            {
                Header: t('Dział'),
                accessor: 'department'
            },
            {
                Header: t('Nazwa zlecenia'),
                accessor: 'application',
            },
            {
                Header: t('Data świadczenia pracy'),
                accessor: 'date'
            },
            {
                Header: t('Pracownik'),
                accessor: 'candidate_name',
                Cell: ({ row }) => {
                    const candidate = row.original?.candidate;
                    return (
                        <User user={candidate} />
                    )
                }
            },
            {
                Header: t('Stanowisko'),
                accessor: 'profession'
            },
            {
                Header: t('Wystawiona ocena'),
                accessor: 'rating',
                Cell: ({ cell: { value } }) => <RatingStars rate={value} small />
            },
        ],
        [t]
    );

    const average = useMemo(() => data.reduce((acc, curr) => acc + parseFloat(curr.rating), 0), [data]);

    return (
        <Paper customStyle={styles.paper}>
            <Table
                columns={columns}
                data={data}
                hideFooter
            />
            <Row end="xs">
                <Col>
                    <Box customStyle={styles.footer}>
                        <Typography customStyle={styles.font}>{t("Średnia ocena działu w wybranym okresie")}</Typography>
                        <RatingStars rate={average / data.length} small />
                    </Box>
                </Col>
            </Row>
        </Paper>
    )
}

export default TableRatings;
